import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2244a104"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "card-header" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("title.preview")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _ctx.data,
      stripe: "",
      style: {"width":"100%"},
      "default-sort": { prop: 'dateTime', order: 'ascending' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "container.name",
          label: _ctx.$t('label.container'),
          width: "150"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "samplingPointType",
          label: _ctx.$t('label.samplingPointType')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "magnitude",
          label: _ctx.$t('label.magnitude')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "codeParameter.code",
          label: _ctx.$t('label.parameter')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "raw",
          label: _ctx.$t('label.raw')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "clean",
          label: _ctx.$t('label.clean')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "event",
          label: _ctx.$t('label.event'),
          formatter: (row) => row.event || ''
        }, null, 8, ["label", "formatter"]),
        _createVNode(_component_el_table_column, { width: "120" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              onClick: ($event: any) => (_ctx.openEditModal(scope.row))
            }, {
              default: _withCtx(() => [
                _createElementVNode("em", {
                  class: "el-icon el-icon-edit fas",
                  title: _ctx.$t('btn.edit')
                }, null, 8, _hoisted_1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "left",
          prop: "dateTime",
          label: _ctx.$t('label.date') + ' (UTC)',
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.dateTime), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      class: "app-table",
      layout: "total, sizes, prev, pager, next, jumper",
      currentPage: _ctx.currentPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
      "page-sizes": [10],
      "page-size": _ctx.rowPerPage,
      total: _ctx.totalRows,
      onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePaginationSize($event))),
      onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePaginationPage($event)))
    }, null, 8, ["currentPage", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      title: _ctx.$t('btn.modify'),
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isModalVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.saveChanges
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.editForm,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.container')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editForm.container.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editForm.container.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.samplingPointType')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editForm.samplingPointType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editForm.samplingPointType) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.magnitude')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editForm.magnitude,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editForm.magnitude) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.raw')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: _ctx.editForm.raw,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editForm.raw) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.clean')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: _ctx.editForm.clean,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editForm.clean) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.value')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: _ctx.editForm.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editForm.value) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.event')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "string",
                  modelValue: _ctx.editForm.event,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editForm.event) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  align: "middle",
                  gutter: "10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 20 }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.allParamsEvent")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.allParams,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.allParams) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}